export default __webpack_public_path__ + "0475b79c8736994dfef5b233cfc6b0f7.ply";